export const PLANS = 'PLANS';
export const PLANS_SUCCESSFUL = 'PLANS_SUCCESSFUL';
